export default {
    numberOfPages: 1,
    page: 1,
    pageSize: 25,
    totalItemCount: 0,
    items: []
};
